/*
 * @Author: Tang Yuxuan
 * @Date: 2020-10-19 16:41:40
 * @LastEditTime: 2020-10-28 11:00:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\oauthapi.js
 */
import http from "./http";
var oauthapi = {
    mobile: 'oauth-api/api/oauth/login/mobile',
    send: 'oauth-api/api/oauth/sms/send',
    // userInfo:'oauth-api/api/uc/info', //用户信息
    userInfo: 'api/user/info',
    wxcode:'api/third-login/wechat/login-ticket',
    iswxcode:'oauth-api/api/third/wechat/login_t',
    wxbindmobile: 'oauth-api/api/third/wechat/bind/mobile',
    qqauthorizeurl: 'oauth-api/api/third/tencent/authorizeurl',
    changemobile: 'oauth-api/api/uc/change/mobile',
    bindwechat:'oauth-api/api/third/wechat/bind_t',
    isbindwechat:'api/third-login/wechat/bind-ticket',
    unbindwechat: 'oauth-api/api/uc/unbind/wechat',
    offUser: 'oauth-api/api/uc/log/off/user',
    feedback: 'oauth-api/api/feedback/add', //提交反馈接口
    feedbackOss: 'oauth-api/api/feedback/get/ossconfig', //获取反馈图片上传oss信息接口
    vipProduct: 'oauth-api/api/vip/get/product',
    vipcreate: 'oauth-api/api/vip/create',
    getOrderState: 'oauth-api/api/vip/getOrderState',
    getmobile: 'oauth-api/api/uc/get/mobile',
    accsend: 'oauth-api/api/uc/sms/send',
    contact: 'oauth-api/api/system/contact',
    appdownImg: 'oauth-api/api/system/set',
    appdownUrl: 'oauth-api/api/system/app-download',
    login: 'api/user/login',
    vipRedirectUrl: "api/system/server-config/attribute/openVip"
};

/**
 * 手机号登录-注册
 * 	"mobile": "",
 *	"sign": "",
 *	"verifyCode": ""
 * @param {*} params
 */
function mobile(params) {
    return http.post(oauthapi.mobile, params);
}
/**
 * 获取验证码
 * businessType 业务类型 '0'手机登录验证码 ,'1'qq注册绑定手机号码发送验证码,'2' 微信注册绑定手机号码发送验证码 '3'更换手机号码发送验证码 '4'验证旧手机号码 '5' 注销用户发送验证码
 * mobile
 */
function send(params) {
    return http.post(oauthapi.send, params);
}

/**
 * 获取用户信息
 */
function userInfo(params){
    return http.get(oauthapi.userInfo,params)
}

/**
 * 获取微信登录二维码
 * businessType 业务类型 验证登录时,如果微信绑定了手机,直接登录并返回code:0 data是token,如果微信未绑定手机,返回code:-2 data:openid ,如果未扫描,返回code:-1
 * 'login_s':'绑定代号, 获取登录状态时传入该参数'
 * 'oper':'操作类型: login_ticket获取登录ticket login_verify:验证ticket是否被扫描'
 */
function wxcode(params) {
    return http.getcode(oauthapi.wxcode, params);
}
function iswxcode(params) {
    return http.get(oauthapi.iswxcode, params);
}
// 微信绑定手机号
//  "mobile": "",
// 	"loginStr": "",   之前获取二维码返回的data.str
// 	"verifyCode": ""
function wxbindmobile(params) {
    return http.post(oauthapi.wxbindmobile, params);
}

// 获取qq授权地址
function qqauthorizeurl(params) {
    return http.get(oauthapi.qqauthorizeurl, params);
}

// 更换手机号绑定
function changemobile(params) {
    return http.post(oauthapi.changemobile, params);
}

/**
 * 绑定微信
 * businessType 业务类型 验证是否绑定 绑定成功返回code:0,data:openid  已经绑定其他账户返回code:201 data:openid
 * 'bind_s':'绑定代号，获取绑定状态时传入该参数'
 * 'oper':'操作类型: wx_bind_ticket获取绑定ticket wx_bind_verify:验证ticket是否被扫描'
 */
function isbindwechat(params) {
    return http.getcode(oauthapi.isbindwechat, params);
}
function bindwechat(params) {
    return http.get(oauthapi.bindwechat, params);
}
// 解绑微信
function unbindwechat(params) {
    return http.post(oauthapi.unbindwechat,params);
}

// 注销账号
function offUser(params) {
    return http.post(oauthapi.offUser,params);
}

// 获取手机号
function getmobile(params) {
    return http.get(oauthapi.getmobile,params);
}

// 问题反馈
function feedback(params) {
    return http.post(oauthapi.feedback,params);
}

// 反馈图片上传
function feedbackOss(params) {
    return http.get(oauthapi.feedbackOss,params);
}

// 获取vip产品列表
function vipProduct(params) {
    return http.get(oauthapi.vipProduct,params);
}

// 创建二维码订单,返回url
function vipcreate(params) {
    return http.get(oauthapi.vipcreate,params);
}

// 获取订单状态
function getOrderState(params) {
    return http.get(oauthapi.getOrderState,params);
}

// 账户中心发送验证码
function accsend(params) {
    return http.post(oauthapi.accsend,params);
}

// 联系我们
function contact(params) {
    return http.get(oauthapi.contact,params);
}

// app下载二维码
function appdownImg(params) {
    return http.get(oauthapi.appdownImg,params);
}

// app下载地址
function appdownUrl(params) {
    return http.get(oauthapi.appdownUrl,params);
}
// 爱学术授权登录
function oauthLogin(params) {
    return http.get(oauthapi.login, params);
}

function vipRedirectUrl(params) {
    return http.get(oauthapi.vipRedirectUrl, params);
}

export default {
  mobile,
  send,
  userInfo,
  wxcode,
  wxbindmobile,
  qqauthorizeurl,
  changemobile,
  bindwechat,
  unbindwechat,
  offUser,
  feedback,
  feedbackOss,
  vipProduct,
  vipcreate,
  getOrderState,
  getmobile,
  accsend,
  contact,
  appdownImg,
  appdownUrl,
  iswxcode,
  isbindwechat,
  oauthLogin,
  vipRedirectUrl
}



// WEBPACK FOOTER //
// ./static/js/oauthapi.js